<template>
  <div
    :class="[{'grid': grid}, {'selected': isSelected}]"
    class="category-card list-item">
    <router-link
      v-if="category"
      :to="`/listen/category/${category.slug}/${category.uuid}'`">
      <div class="card-content">
        <p
          v-if="category.name"
          class="t-l">{{ category.name || category.title }}</p>
      </div>
    </router-link>
  </div>
</template>
<script>
import placeholder from '../assets/images/placeholder.png';

export default {
  name: 'CategoryCard',
  props: {
    category: {
      type: Object,
      default: () => {},
    },
    grid: {
      type: Boolean,
      default: false,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSelected: false,
      placeholder,
    };
  },
  watch: {
    selected(newVal) {
      this.isSelected = newVal;
    },
  },
  methods: {
    categoryPage(id) {
      if (!this.selectable) {
        this.$router.push(`/listen/category/${this.category.slug}/${id}`);
      } else {
        this.isSelected = !this.isSelected;
        this.$emit('onSelect', {
          id,
          isSelected: this.isSelected,
        });
      }
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";

.category-card {
  cursor: pointer;
  position: relative;
  .overlay {
    position: absolute;
    z-index: 2;
    background: rgba(0.39, 0.39, 0.39, .4);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .card-content {
    height: 142px;
    width: 227px;
    border-radius: 4px;
    background: linear-gradient(180deg, #FFE6C2 0%, #FFC98F 100%);
    img {
      z-index:1;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
    p {
      text-transform: capitalize;
      font-size: 16px;
      color:$black;
      padding: 16px 16px;
      z-index:30;
      margin: 0;
    }
  }
}

.category-card.grid {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 207px;
  margin-left: 8px;
  margin-right: 8px;
  margin-bottom: 16px;

  .el-card {
    width: 100%;
    height: 100%;
  }

  .card-content {
    width: 100%;
    height: 131px;
  }
}

@media (max-width: 1024px) {
  .category-card.grid {
    flex-basis: 175px;

    .card-content {
      height: 111px;
    }
  }
}

@media (max-width: 768px) {
  .category-card.grid {
    flex-basis: 164px;

    .card-content {
      height: 103px;
    }
  }
}

@media (max-width: 567px) {
  .category-card.grid {
    flex-basis: 147px;

    .card-content {
      height: 92px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/CategoryCard.vue